import { CustomerOverviewSchema } from '@weft/api-definition';
import type { z } from 'zod';

export const PlanAssignmentCustomerDataSchema = CustomerOverviewSchema.pick({
  id: true,
  name: true,
});

export type PlanAssignmentCustomerData = z.infer<typeof PlanAssignmentCustomerDataSchema>;
